// Ekhtibary


import React from 'react';

export function Ekhtibary () {
  return (
    <div className='bg-white text-center'>
      <h1>Ekhtibary Project</h1>
      <p>Details about the Sorcero project...</p>
      <p>More content goes here...</p>
    </div>
  );
};

export default Ekhtibary;
